<template>
  <v-container fluid class="pa-6">
    <!-- KPI Cards Section -->
    <v-row class="mb-4 mb-md-6">
      <v-col cols="6" sm="6" lg="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3 pa-sm-5">
            <div class="kpi-icon d-none d-sm-flex">
              <v-icon color="primary">mdi-sale</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Tipo de Movimiento</div>
              <div class="kpi-value">Promoción</div>
              <div class="kpi-subtitle d-none d-sm-flex">
                <v-icon x-small color="success">mdi-package-variant</v-icon>
                Traslado de productos
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6" lg="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3 pa-sm-5">
            <div class="kpi-icon d-none d-sm-flex">
              <v-icon color="success">mdi-package-variant-closed</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Productos</div>
              <div class="kpi-value">{{ items.length }}</div>
              <div class="kpi-subtitle d-none d-sm-flex">
                <v-icon x-small color="info">mdi-format-list-bulleted</v-icon>
                Seleccionados
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6" lg="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3 pa-sm-5">
            <div class="kpi-icon d-none d-sm-flex">
              <v-icon color="warning">mdi-cube-outline</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Unidades</div>
              <div class="kpi-value">{{ formatNumber(totals.qty) }}</div>
              <div class="kpi-subtitle d-none d-sm-flex">Total a trasladar</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6" lg="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3 pa-sm-5">
            <div class="kpi-icon d-none d-sm-flex">
              <v-icon color="info">mdi-cash</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Valor Total</div>
              <div class="kpi-value">{{ formatCurrency(totals.total) }}</div>
              <div class="kpi-subtitle d-none d-sm-flex">Valor del traslado</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Content Card -->
    <v-card class="main-card elevation-0" outlined>
      <!-- Header -->
      <v-card-title class="pa-0">
        <v-toolbar flat class="minimal-toolbar">
          <h2 class="section-title" :class="{ 'text-h6': $vuetify.breakpoint.mobile }">
            Traslado a Promoción
          </h2>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Store and Responsible Info -->
      <v-card-text class="py-4">
        <v-row>
          <v-col cols="12" md="6">
            <div class="info-section">
              <h3 class="info-title mb-3">
                <v-icon small class="mr-2">mdi-store</v-icon>
                Información del Establecimiento
              </h3>
              <div class="info-content">
                <div class="info-item">
                  <strong>{{ store.PartyName }}</strong>
                </div>
                <div class="info-item text-body-2 grey--text">
                  {{ store.store_address + " , " + store.store_city }}
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="info-section">
              <div class="d-flex justify-space-between align-center mb-3">
                <h3 class="info-title">
                  <v-icon small class="mr-2">mdi-account-tie</v-icon>
                  Responsable del Traslado
                </h3>
                <v-btn
                  color="primary"
                  fab
                  x-small
                  @click="client_dialog = !client_dialog"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </div>
              <div class="info-content" v-if="client.PartyName">
                <div class="info-item">
                  <strong>{{ client.PartyName }}</strong>
                </div>
                <div class="info-item text-body-2">
                  ID: {{ client.PartyIdentification }}
                </div>
                <div class="info-item text-body-2 grey--text">
                  Email: {{ client.client_email || "No registrado" }}
                </div>
                <div class="info-item text-body-2 grey--text">
                  Tel: {{ client.client_phone || "No registrado" }}
                </div>
              </div>
              <div v-else class="text-center py-4">
                <v-icon color="grey lighten-2" size="48">mdi-account-question</v-icon>
                <p class="grey--text mt-2 mb-0">No se ha definido un responsable</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Products Section -->
      <v-card-text class="py-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <h3 class="section-subtitle">
            <v-icon small class="mr-2">mdi-package-variant</v-icon>
            Productos a Trasladar
          </h3>
          <v-btn color="primary" fab small @click="search_dialog = !search_dialog">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>

        <!-- Desktop Table -->
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-data-table
            :headers="headers_items"
            :items="items"
            :items-per-page="5"
            item-key="ean"
            class="minimal-table"
            :loading="loading_status"
            loader-height="3"
            loading-text="Cargando..."
            hide-default-footer
          >
            <!-- Product Info -->
            <template v-slot:[`item.product`]="{ item }">
              <div class="product-info">
                <div class="product-main">
                  <span class="font-weight-medium">{{ item.refe }}</span>
                  <v-chip x-small label class="ml-2">{{ item.brand }}</v-chip>
                </div>
                <div class="product-details text-caption grey--text">
                  {{ item.category }} • {{ item.groupName }}
                </div>
              </div>
            </template>

            <!-- Variant -->
            <template v-slot:[`item.variant`]="{ item }">
              <div class="variant-info">
                <v-chip small label class="mr-1">
                  {{ item.colorName }}
                </v-chip>
                <v-chip small label outlined> Talla {{ item.talla }} </v-chip>
              </div>
            </template>

            <!-- Price -->
            <template v-slot:[`item.precio`]="{ item }">
              <div class="text-right font-weight-medium">
                {{ formatCurrency(item.precio) }}
              </div>
            </template>

            <!-- Quantity -->
            <template v-slot:[`item.cantidad`]="{ item }">
              <div class="text-right font-weight-bold primary--text">
                {{ formatNumber(item.cantidad) }} und
              </div>
            </template>

            <!-- Actions -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon x-small @click="removeItem(item)">
                <v-icon small color="error">mdi-delete</v-icon>
              </v-btn>
            </template>

            <!-- Empty state -->
            <template v-slot:no-data>
              <div class="text-center py-8">
                <v-icon size="64" color="grey lighten-2">mdi-package-variant</v-icon>
                <h3 class="text-h6 mt-4 grey--text">No hay productos agregados</h3>
                <p class="grey--text mt-2">
                  Haz clic en el botón + para agregar productos
                </p>
              </div>
            </template>

            <!-- Footer totals -->
            <template slot="body.append" v-if="items.length > 0">
              <tr class="grey lighten-4">
                <td colspan="3" class="text-right font-weight-bold">TOTAL</td>
                <td class="text-right font-weight-bold">
                  {{ formatCurrency(totals.total) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ formatNumber(totals.qty) }} und
                </td>
                <td></td>
              </tr>
            </template>
          </v-data-table>
        </template>

        <!-- Mobile List -->
        <template v-else>
          <v-list v-if="items.length > 0" class="mobile-list">
            <template v-for="(item, index) in items">
              <v-list-item :key="item.ean" class="px-0 py-3">
                <v-list-item-content>
                  <div class="d-flex justify-space-between align-start mb-2">
                    <div class="flex-grow-1 mr-2">
                      <div class="font-weight-medium">
                        {{ item.refe }} - {{ item.brand }}
                      </div>
                      <div class="text-body-2 grey--text">{{ item.category }}</div>
                      <div class="mt-1">
                        <v-chip x-small label class="mr-1">{{ item.colorName }}</v-chip>
                        <v-chip x-small label outlined>T. {{ item.talla }}</v-chip>
                      </div>
                    </div>
                    <div class="text-right">
                      <div class="font-weight-bold primary--text">
                        {{ item.cantidad }} und
                      </div>
                      <div class="text-body-2">{{ formatCurrency(item.precio) }}</div>
                      <v-btn icon x-small @click="removeItem(item)" class="mt-1">
                        <v-icon small color="error">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="index < items.length - 1" :key="`div-${item.ean}`" />
            </template>
          </v-list>

          <v-card v-else flat class="text-center py-8">
            <v-icon size="48" color="grey lighten-2">mdi-package-variant</v-icon>
            <p class="grey--text mt-2">No hay productos agregados</p>
          </v-card>

          <!-- Mobile Total -->
          <v-card v-if="items.length > 0" flat class="grey lighten-4 pa-3 mt-3">
            <div class="d-flex justify-space-between align-center">
              <span class="font-weight-bold">TOTAL</span>
              <div class="text-right">
                <div class="font-weight-bold">{{ formatCurrency(totals.total) }}</div>
                <div class="text-caption">{{ formatNumber(totals.qty) }} unidades</div>
              </div>
            </div>
          </v-card>
        </template>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Signature and Motive Section -->
      <v-card-text class="py-4">
        <v-row>
          <v-col cols="12" md="6">
            <div class="info-section h-100">
              <h3 class="info-title mb-3">
                <v-icon small class="mr-2">mdi-draw</v-icon>
                Firma del Responsable
              </h3>
              <div class="signature-container">
                <VueSignaturePad
                  class="signature-pad"
                  width="100%"
                  height="150px"
                  ref="signaturePad"
                />
              </div>
              <v-btn text small color="primary" @click="clearSignature" class="mt-2">
                <v-icon left small>mdi-eraser</v-icon>
                Limpiar firma
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <v-form v-model="validatemotive" ref="motiveform" @submit="save_receipt">
              <div class="info-section h-100">
                <h3 class="info-title mb-3">
                  <v-icon small class="mr-2">mdi-text-box-outline</v-icon>
                  Concepto del Traslado
                </h3>
                <v-select
                  v-model="motive"
                  :items="FP"
                  item-value="codigo"
                  item-text="valor"
                  return-object
                  outlined
                  dense
                  :rules="f_required"
                  placeholder="Seleccione el motivo del traslado"
                />
                <v-btn
                  color="success"
                  type="submit"
                  :loading="loading_status"
                  :disabled="!canSubmit"
                  block
                  large
                  class="mt-4"
                >
                  <v-icon left>mdi-check</v-icon>
                  Registrar Traslado
                </v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Client Dialog -->
    <v-dialog
      v-model="client_dialog"
      max-width="600px"
      :fullscreen="$vuetify.breakpoint.mobile"
    >
      <v-card>
        <v-toolbar flat class="minimal-toolbar">
          <v-toolbar-title>Responsable del Traslado</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="client_dialog = !client_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 pa-md-6">
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="client.typeid"
                hide-details="auto"
                :items="id_lst"
                item-value="code"
                item-text="name"
                label="Tipo de documento"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="client.PartyIdentification"
                label="Número de documento"
                ref="idNumber"
                hide-details="auto"
                outlined
                dense
                @keyup="validateID"
                autofocus
                clearable
                prepend-inner-icon="mdi-card-account-details"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="client.PartyName"
                label="Nombre Completo"
                hide-details="auto"
                outlined
                dense
                prepend-inner-icon="mdi-account"
              />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="client.client_email"
                label="Correo Electrónico"
                hide-details="auto"
                outlined
                dense
                type="email"
                prepend-inner-icon="mdi-email"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="client.client_phone"
                label="Teléfono"
                hide-details="auto"
                outlined
                dense
                prepend-inner-icon="mdi-phone"
              />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="client.AddressLine"
                label="Dirección"
                hide-details="auto"
                outlined
                dense
                prepend-inner-icon="mdi-map-marker"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="client.CityName"
                label="Ciudad"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="client_dialog = false">Cancelar</v-btn>
          <v-btn color="success" @click="saveClient"> Guardar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Search Dialog -->
    <v-dialog
      v-model="search_dialog"
      max-width="900px"
      :fullscreen="$vuetify.breakpoint.mobile"
    >
      <v-form v-model="search_valid" ref="searchform" @submit="search_inventory">
        <v-card>
          <v-toolbar flat class="minimal-toolbar">
            <v-toolbar-title>Buscar en el Inventario</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="search_dialog = !search_dialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-4">
            <v-row class="mb-4">
              <v-col cols="12" sm="3">
                <v-select
                  v-model="filters.categoria"
                  :items="CT"
                  item-value="codigo"
                  item-text="valor"
                  label="Categoría"
                  hide-details="auto"
                  outlined
                  dense
                  clearable
                  prepend-inner-icon="mdi-shape"
                />
              </v-col>
              <v-col cols="12" sm="3">
                <v-select
                  v-model="filters.marca"
                  :items="MR"
                  item-value="codigo"
                  item-text="valor"
                  label="Marca"
                  clearable
                  hide-details="auto"
                  outlined
                  dense
                  prepend-inner-icon="mdi-tag"
                />
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  v-model="filters.refe"
                  label="Referencia"
                  clearable
                  hide-details="auto"
                  outlined
                  dense
                  required
                  prepend-inner-icon="mdi-barcode"
                />
              </v-col>
              <v-col cols="12" sm="3" class="d-flex align-center">
                <v-btn
                  :disabled="!search_valid"
                  block
                  color="primary"
                  type="submit"
                  :loading="loading_status"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>

            <!-- Results Table -->
            <v-data-table
              :headers="headers"
              :items="inventory_lst"
              :items-per-page="10"
              class="minimal-table"
              item-key="ean"
              :loading="loading_status"
              loader-height="3"
              loading-text="Cargando..."
            >
              <!-- Product Column -->
              <template v-slot:[`item.product`]="{ item }">
                <div class="product-info">
                  <div class="product-main">
                    <span class="font-weight-medium">{{ item.refe }}</span>
                    <v-chip x-small label class="ml-2">{{ item.brand }}</v-chip>
                  </div>
                  <div class="product-details text-caption grey--text">
                    {{ item.category }} / {{ item.groupName }}
                  </div>
                </div>
              </template>

              <!-- Color/Size -->
              <template v-slot:[`item.variant`]="{ item }">
                <div class="variant-info">
                  <v-chip small label class="mr-1">{{ item.colorName }}</v-chip>
                  <v-chip small label outlined>T. {{ item.talla }}</v-chip>
                </div>
              </template>

              <!-- Price -->
              <template v-slot:[`item.precio`]="{ item }">
                <div class="text-right">{{ formatCurrency(item.precio) }}</div>
              </template>

              <!-- Stock -->
              <template v-slot:[`item.cantidad`]="{ item }">
                <div class="text-right font-weight-medium">
                  <span
                    :class="{
                      'success--text': item.cantidad > 10,
                      'warning--text': item.cantidad > 0 && item.cantidad <= 10,
                      'error--text': item.cantidad === 0,
                    }"
                  >
                    {{ formatNumber(item.cantidad) }}
                  </span>
                </div>
              </template>

              <!-- Actions -->
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  icon
                  color="success"
                  @click="add2cart(item)"
                  :disabled="item.cantidad === 0"
                >
                  <v-icon>mdi-plus-box-outline</v-icon>
                </v-btn>
              </template>

              <!-- Empty state -->
              <template v-slot:no-data>
                <div class="text-center py-8">
                  <v-icon size="64" color="grey lighten-2">mdi-magnify-close</v-icon>
                  <h3 class="text-h6 mt-4 grey--text">No se encontraron productos</h3>
                  <p class="grey--text mt-2">Intenta con otros criterios de búsqueda</p>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Print Navigation Drawer -->
    <v-navigation-drawer
      right
      class="navigation-drawer"
      :value="showPrint"
      width="400px"
      app
    >
      <v-card height="100vh">
        <v-toolbar dark>
          <v-toolbar-title>Traslado a Promoción</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn fab icon @click="showPrint = !showPrint">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-img height="100%" width="100%" class="white" :src="dataURL"></v-img>
        </v-card-text>
      </v-card>
      <v-toolbar class="fixed-footer">
        <v-spacer></v-spacer>
        <v-btn color="success" @click="print_doc">
          <v-icon left>mdi-printer</v-icon>
          Imprimir
        </v-btn>
      </v-toolbar>
    </v-navigation-drawer>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { webserver, getToday } from "@/services/webserver.js";
import createClient from "@/utils/createClient.js";
import createPayment from "@/utils/createPayment.js";
import create_item from "@/utils/create_item.js";

export default {
  components: {},
  data() {
    return {
      // UI State
      search: "",
      searcText: "",
      issueDate: getToday(),
      searchvalid: false,
      validatemotive: false,
      client_dialog: false,
      payment_dialogo: false,
      concepts_dialog: false,
      product_dialog: false,
      loading_status: false,
      validConcept: false,
      payvalid: false,
      showPrint: false,
      search_valid: false,
      search_dialog: false,

      // Snackbar
      snackbar: {
        show: false,
        text: "",
        color: "success",
        timeout: 3000,
      },

      // Data
      receipt: null,
      signature: null,
      payment: createPayment(),
      totals: { qty: 0, total: 0, tax: 0, paid: 0, unpaid: 0 },

      // Lists
      id_lst: [
        { code: "13", name: "Cédula de ciudadanía" },
        { code: "31", name: "NIT" },
        { code: "11", name: "Registro civil" },
        { code: "12", name: "Tarjeta de identidad" },
        { code: "21", name: "Tarjeta de extranjería" },
        { code: "22", name: "Cédula de extranjería" },
        { code: "41", name: "Pasaporte" },
        { code: "42", name: "Documento de identificación extranjero" },
        { code: "50", name: "NIT de otro país" },
      ],

      // Headers - Modernizados
      headers: [
        {
          text: "Producto",
          align: "start",
          sortable: false,
          value: "product",
          width: "35%",
        },
        {
          text: "Variante",
          align: "start",
          sortable: false,
          value: "variant",
          width: "25%",
        },
        {
          text: "Precio",
          align: "end",
          sortable: true,
          value: "precio",
          width: "15%",
        },
        {
          text: "Stock",
          align: "end",
          sortable: true,
          value: "cantidad",
          width: "15%",
        },
        {
          text: "",
          value: "actions",
          align: "center",
          sortable: false,
          width: "10%",
        },
      ],

      headers_items: [
        {
          text: "Producto",
          align: "start",
          sortable: false,
          value: "product",
          width: "40%",
        },
        {
          text: "Variante",
          align: "start",
          sortable: false,
          value: "variant",
          width: "25%",
        },
        {
          text: "Precio",
          align: "end",
          sortable: true,
          value: "precio",
          width: "15%",
        },
        {
          text: "Cantidad",
          align: "end",
          sortable: true,
          value: "cantidad",
          width: "15%",
        },
        {
          text: "",
          value: "actions",
          align: "center",
          sortable: false,
          width: "5%",
        },
      ],

      // Models
      store: createClient(),
      concept: create_item(),
      concepts: [],
      concept_lst: [],
      payments: [],
      payRefe: false,
      payValue: false,
      pay_mode: {
        codigo: "01",
        valor: "EFECTIVO",
      },
      FP: [],
      client: createClient(),
      signatureStock: null,
      f_required: [(v) => !!v || "Campo requerido"],
      payRule: [
        (v) => !!v || "Forma de pago requerida",
        (v) =>
          (v && v <= this.totals.unpaid) ||
          "Valor max " + this.totals.unpaid.toLocaleString(2),
      ],
      dataURL: "",
      items: [],
      motive: { codigo: null, valor: null },
      returns: {
        seller: {},
        paidTo: {},
        items: [],
        payments: [],
      },
      validate_return: false,
      valide_qry: false,
      CT: null,
      MR: null,
      colors: [],
      filters: { categoria: "", marca: "", refe: "", id_pos: "" },
      inventory_lst: [],
    };
  },

  computed: {
    canSubmit() {
      return (
        this.items.length > 0 &&
        this.motive.codigo &&
        this.client.PartyName &&
        this.validatemotive
      );
    },
  },

  mounted() {
    console.log(window.settings);
    this.store = window.store;
    this.FP = window.settings["P-ENTRADA"];
    this.CT = window.settings.CATEGORIA;
    this.MR = window.settings.MARCA;
    this.colors = window.settings.COLOR;
    this.client = {
      PartyName: null,
      PartyIdentification: null,
      client_email: null,
      client_phone: null,
    };
  },

  methods: {
    // Format currency
    formatCurrency(value) {
      if (!value && value !== 0) return "$0";
      return (
        "$" +
        parseFloat(value).toLocaleString("es", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      );
    },

    // Format number
    formatNumber(value) {
      if (!value && value !== 0) return "0";
      return parseFloat(value).toLocaleString("es", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },

    // Show message
    showMessage(text, color = "success") {
      this.snackbar = {
        show: true,
        text,
        color,
        timeout: 3000,
      };
    },

    get_categoria_name(codigo) {
      if (!codigo) return "";
      // Buscar en window.settings["CATEGORIA"] que es un array
      var categorias = window.settings && window.settings["CATEGORIA"] 
        ? window.settings["CATEGORIA"].find(item => item.codigo === codigo)
        : null;
      // Devolver el valor si existe y es diferente del código
      return categorias && categorias.valor && categorias.valor !== codigo 
        ? categorias.valor : codigo;
    },

    get_grupo_name(codigo) {
      if (!codigo) return "";
      // Buscar en window.settings["GRUPO"] que es un array
      var grupos = window.settings && window.settings["GRUPO"] 
        ? window.settings["GRUPO"].find(item => item.codigo === codigo)
        : null;
      // Devolver el valor si existe y es diferente del código
      return grupos && grupos.valor && grupos.valor !== codigo 
        ? grupos.valor : codigo;
    },

    // Clear signature
    clearSignature() {
      if (this.$refs.signaturePad) {
        this.$refs.signaturePad.clearSignature();
      }
    },

    onBegin() {
      //console.log('=== Begin ===');
    },

    onEnd() {
      //console.log('=== End ===');
    },

    get_name_typeId(e) {
      var index = this.id_lst.findIndex((itm) => itm.code === e);
      if (index >= 0) {
        return this.id_lst[index].name;
      }
    },

    get_concept_text(e) {
      var index = this.concept_lst.findIndex((itm) => itm.codigo === e);
      if (index >= 0) {
        return this.concept_lst[index].valor;
      }
    },

    validateID(e) {
      if (e.keyCode === 13) {
        var qry = {
          store: window.store.store_id,
          PartyIdentification: this.client.PartyIdentification,
        };
        webserver("get_client_info", qry, (data) => {
          if (data) {
            this.client = data;
            this.showMessage("Cliente encontrado", "success");
          } else {
            this.showMessage("Cliente no encontrado", "warning");
          }
        });
      }
    },

    saveClient() {
      this.client_dialog = false;
      this.valide_qry = !!this.client.PartyName;
      this.showMessage("Responsable actualizado", "success");
    },

    add2cart(e) {
      delete e.order_date;
      e.cantidad = parseFloat(e.cantidad);
      const newItem = { ...e };

      var index = this.items.findIndex((itm) => itm.ean === newItem.ean);
      if (index === -1) {
        this.items.push(newItem);
        this.showMessage(`${newItem.refe} agregado`, "success");
      } else {
        this.items[index].cantidad = this.items[index].cantidad + newItem.cantidad;
        this.showMessage(`Cantidad actualizada para ${newItem.refe}`, "info");
      }

      this.updateTotal();
      this.search_dialog = false;
    },

    removeItem(item) {
      const index = this.items.findIndex((itm) => itm.ean === item.ean);
      if (index !== -1) {
        this.items.splice(index, 1);
        this.updateTotal();
        this.showMessage(`${item.refe} eliminado`, "info");
      }
    },

    updateTotal() {
      this.totals.qty = 0;
      this.totals.total = 0;
      this.totals.tax = 0;
      this.totals.paid = 0;
      this.totals.unpaid = 0;

      this.items.forEach((itm) => {
        this.totals.qty += parseFloat(itm.cantidad);
        this.totals.total += parseFloat(itm.cantidad) * parseFloat(itm.precio);
      });

      this.payments.forEach((itm) => {
        this.totals.paid += parseFloat(itm.payment_value);
      });

      this.totals.unpaid = this.totals.total - this.totals.paid;
      this.payment.payment_value = this.totals.unpaid;
    },

    search_inventory(e) {
      e.preventDefault();
      this.filters.id_pos = window.store.store_id;

      this.loading_status = true;

      var qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: this.filters,
      };

      webserver(
        "get_catalog",
        qry,
        (data) => {
          this.loading_status = false;
          this.inventory_lst = data || [];

          if (data && data.length > 0) {
            this.showMessage(`${data.length} productos encontrados`, "success");
          } else {
            this.showMessage("No se encontraron productos", "warning");
          }
        },
        () => {
          this.loading_status = false;
          this.showMessage("Error al buscar productos", "error");
        }
      );
    },

    save_receipt(e) {
      e.preventDefault();
      this.$refs.motiveform.validate();

      if (!this.client.PartyName) {
        this.showMessage("Debe definir un responsable", "warning");
        return;
      }

      if (!this.motive.codigo) {
        this.showMessage("Debe seleccionar un motivo", "warning");
        return;
      }

      if (this.items.length === 0) {
        this.showMessage("Debe agregar al menos un producto", "warning");
        return;
      }

      this.loading_status = true;

      var qry = {
        doc: {
          doc_type: "P-IN",
          doc_value: this.totals.total,
          store: window.store.store_id,
          userId: window.profile.user_email,
        },
        items: this.items,
        paidTo: this.client,
        seller: window.seller,
        store: window.store.store_id,
        payments: [
          {
            payment_code: this.motive.codigo,
            payment_concept: this.motive.valor,
            payment_reference: "",
            payment_value: this.totals.total,
          },
        ],
      };

      webserver(
        "put_stock",
        qry,
        (data) => {
          this.loading_status = false;
          this.showMessage("Traslado registrado exitosamente", "success");
          this.print_receipt(data);
          this.resetDoc();
        },
        () => {
          this.loading_status = false;
          this.showMessage("Error al registrar el traslado", "error");
        }
      );
    },

    resetDoc() {
      this.motive = { codigo: null, valor: null };
      this.payments = [];
      this.items = [];
      this.client = createClient();
      this.valide_qry = false;
      this.client = {
        PartyName: null,
        PartyIdentification: null,
        client_email: null,
        client_phone: null,
      };
      this.updateTotal();
      this.clearSignature();
    },

    print_doc() {
      if (this.dataURL) {
        var a = window.open("", "", "height=600, width=400");
        a.document.write('<img src="' + this.dataURL + '"  width="100%">');
        a.print();
        a.document.close();
        setTimeout(() => {
          a.close();
        }, 500);
      }
    },

    print_receipt(data) {
      var LS = 50;
      var itemsQty = data.items.length * LS * 3;
      const elem = document.createElement("canvas");
      elem.width = 945;
      elem.height = 1800 + itemsQty;
      var center = elem.width / 2;
      var left = 10;
      var line = 150;
      var right = elem.width - left;
      const ctx = elem.getContext("2d");

      ctx.font = "bold 40px Arial";
      ctx.textAlign = "center";

      ctx.font = "bold 60px Arial";
      ctx.fillText(window.seller.PartyIdentification_Id, center, line);
      line += LS;
      ctx.font = "bold 40px Arial";
      ctx.fillText(window.seller.PartyName, center, line);
      line += LS;
      ctx.fillText("Nit : " + window.seller.PartyIdentification, center, line);

      line += LS;
      ctx.fillText(
        window.seller.AddressLine + ", " + window.seller.CityName,
        center,
        line
      );
      line += LS;
      ctx.font = "bold 35px Arial";
      ctx.fillText("TRASLADO A PROMOCIÓN", center, line);
      ctx.font = "bold 40px Arial";
      line += LS;
      ctx.fillText("No. " + data.document.doc_number, center, line);
      line += LS;
      ctx.fillText(data.document.issueDate, center, line);
      line += LS;
      ctx.textAlign = "start";
      ctx.fillText("C.C./Nit : " + data.buyer.PartyIdentification, left, line);
      line += LS;
      ctx.fillText("Nombre    : " + data.buyer.PartyName, left, line);
      line += LS;
      line += LS;
      ctx.font = "bold 40px Arial";
      ctx.textAlign = "center";
      ctx.fillText("Productos", center, line);
      line += LS;
      ctx.beginPath();
      ctx.moveTo(left, line - 10);
      ctx.lineTo(right, line - 10);
      ctx.stroke();
      line += LS;

      data.items.forEach((row) => {
        var price = parseFloat(row.precio) * parseFloat(row.cantidad);
        var description =
          row.brand + "-" + row.refe + "-" + row.colorName + "-" + row.talla;
        ctx.textAlign = "start";
        ctx.fillText(description, left, line);
        ctx.textAlign = "end";
        ctx.fillText(price.toLocaleString(), right, line);
        line += LS;
      });

      ctx.beginPath();
      ctx.moveTo(left, line - 10);
      ctx.lineTo(right, line - 10);
      ctx.stroke();
      line += LS;

      line += LS;

      ctx.textAlign = "center";
      ctx.fillText("Concepto del Traslado", center, line);
      line += LS;

      data.payments.forEach((row) => {
        ctx.textAlign = "start";
        ctx.fillText(row.payment_concept + " - " + row.payment_reference, left, line);
        ctx.textAlign = "end";
        ctx.fillText(parseInt(row.payment_value).toLocaleString(), right, line);
        line += LS;
      });
      line += LS;

      line += LS;
      line += LS;

      this.dataURL = elem.toDataURL();
      this.showPrint = true;
    },
  },
};
</script>

<style scoped>
/* KPI Cards */
.kpi-card {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.kpi-card .v-card__text {
  display: flex;
  align-items: center;
  gap: 16px;
}

.kpi-icon {
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kpi-icon .v-icon {
  font-size: 28px !important;
}

.kpi-content {
  flex: 1;
  min-width: 0;
}

.kpi-label {
  font-size: 0.875rem;
  color: #666;
  font-weight: 500;
  margin-bottom: 4px;
}

.kpi-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
}

.kpi-subtitle {
  font-size: 0.75rem;
  color: #999;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Main Card */
.main-card {
  border: 1px solid #e0e0e0;
}

.minimal-toolbar {
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 24px;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.section-subtitle {
  font-size: 1.125rem;
  font-weight: 600;
  color: #444;
  display: flex;
  align-items: center;
}

/* Info Sections */
.info-section {
  padding: 16px;
  background-color: #fafafa;
  border-radius: 8px;
  height: 100%;
}

.info-title {
  font-size: 1rem;
  font-weight: 600;
  color: #666;
  margin: 0;
  display: flex;
  align-items: center;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item {
  line-height: 1.4;
}

/* Signature */
.signature-container {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.signature-pad {
  display: block;
}

/* Data Table */
.minimal-table {
  border: none !important;
}

.minimal-table >>> .v-data-table__wrapper {
  border: none;
  overflow-x: auto;
}

.minimal-table >>> thead tr th {
  background-color: #fafafa !important;
  font-weight: 600 !important;
  color: #666 !important;
  border-bottom: 2px solid #e0e0e0 !important;
  font-size: 0.875rem !important;
  padding: 12px 16px !important;
}

.minimal-table >>> tbody tr {
  border-bottom: 1px solid #f0f0f0 !important;
  transition: background-color 0.2s;
}

.minimal-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.minimal-table >>> tbody tr td {
  padding: 12px 16px !important;
  font-size: 0.875rem !important;
}

/* Custom cells */
.product-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.product-main {
  display: flex;
  align-items: center;
  gap: 8px;
}

.variant-info {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

/* Mobile List */
.mobile-list {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.mobile-list .v-list-item {
  border-bottom: 1px solid #f0f0f0;
}

.mobile-list .v-list-item:last-child {
  border-bottom: none;
}

/* Fixed Footer */
.fixed-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #e0e0e0;
}

/* Loading */
.minimal-table >>> .v-data-table__progress {
  height: 3px !important;
}

/* Responsive */
@media (max-width: 600px) {
  .kpi-value {
    font-size: 1.25rem;
  }

  .section-title {
    font-size: 1.125rem;
  }

  .section-subtitle {
    font-size: 1rem;
  }

  .kpi-card .v-card__text {
    flex-direction: column;
    text-align: center;
    padding: 16px !important;
  }

  .kpi-icon {
    margin-bottom: 8px;
  }

  .minimal-toolbar {
    padding: 12px 16px;
  }

  .info-section {
    padding: 12px;
  }
}

@media (max-width: 960px) {
  .kpi-value {
    font-size: 1.5rem;
  }

  .section-title {
    font-size: 1.25rem;
  }

  .kpi-card .v-card__text {
    flex-direction: row;
    text-align: left;
  }
}
</style>
